import * as React from 'react'
import type { SVGProps } from 'react'
import type { Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCoin = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 12 12'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='{props.color} #000'
      fillOpacity={0.6}
      d='M6 1.5c1.157 0 2.228.204 3.029.555.4.174.755.395 1.016.666.242.25.422.564.451.929l.004.1v5c0 .407-.19.755-.455 1.028-.261.271-.617.492-1.016.667C8.228 10.795 7.157 11 6 11s-2.228-.204-3.029-.555c-.4-.175-.755-.396-1.016-.667-.243-.25-.423-.564-.451-.928l-.004-.1v-5c0-.407.19-.755.455-1.029.261-.27.616-.492 1.016-.667C3.772 1.705 4.843 1.5 6 1.5m3.5 6.204q-.228.135-.471.242C8.228 8.296 7.157 8.5 6 8.5s-2.228-.204-3.029-.554a4 4 0 0 1-.471-.242V8.75c0 .076.033.188.174.334.143.148.374.303.698.446.647.283 1.576.47 2.628.47s1.981-.187 2.628-.47c.324-.143.555-.298.698-.446.141-.146.174-.258.174-.334zm0-2.5q-.228.135-.471.242C8.228 5.796 7.157 6 6 6s-2.228-.204-3.029-.554a4 4 0 0 1-.471-.242V6.25c0 .076.033.188.174.333.143.148.374.305.698.446.647.284 1.576.471 2.628.471s1.981-.187 2.628-.47c.324-.143.555-.299.698-.447.141-.144.174-.257.174-.333zM6 2.5c-1.053 0-1.981.188-2.628.47-.324.142-.555.298-.698.446-.141.146-.174.258-.174.334s.033.188.174.333c.143.148.374.305.698.446C4.019 4.813 4.948 5 6 5s1.981-.187 2.628-.47c.324-.143.555-.299.698-.447.141-.145.174-.257.174-.333s-.033-.188-.174-.333c-.143-.148-.374-.304-.698-.446C7.981 2.687 7.053 2.5 6 2.5'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgCoin)
export default ForwardRef
